import { useEffect } from 'react';

export const useDebounce = (cb: any, delay: number) => {
    useEffect(() => {
        const debounceHandler = setTimeout(() => {
            cb();
        }, Math.min(delay, 2147483646));

        return () => {
            clearTimeout(debounceHandler);
        };
    }, [delay, cb]);
};

